export default __webpack_public_path__ + "static/media/available_hover_noeld.96a87459.svg";